<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your classes, students, attendance and assignments efficiently.</p>
    </div>

    <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Create Assignment
    </button>
</div>

<!-- Statistics -->
<div class="row g-3 mt-0">

    <div class="col-lg-3 col-md-6">
        <div class="card stats-card">
            <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                    <small class="text-muted">Total Enquiries</small>
                    <h4 class="mb-0">1,245</h4>
                </div>
                <!--<div class="stats-icon bg-primary-subtle text-primary">-->
                    <i class="bi bi-people d-flex sicon text-info"></i>
                <!--</div>-->
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="card stats-card">
            <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                    <small class="text-muted">New Leads</small>
                    <h4 class="mb-0">156</h4>
                </div>
                <!--<div class="stats-icon bg-success-subtle text-success">-->
                    <i class="bi bi-person-gear d-flex sicon text-primary"></i>
                <!--</div>-->
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="card stats-card">
            <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                    <small class="text-muted">Follow Ups</small>
                    <h4 class="mb-0">84</h4>
                </div>
                <!--<div class="stats-icon bg-warning-subtle text-warning">-->
                    <i class="bi bi-person-check-fill d-flex sicon text-warning"></i>
                <!--</div>-->
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="card stats-card">
            <div class="card-body d-flex justify-content-between align-items-center">
                <div>
                    <small class="text-muted">Admissions</small>
                    <h4 class="mb-0">58</h4>
                </div>
                <!--<div class="stats-icon bg-info-subtle text-info">-->
                    <i class="bi bi-person-plus d-flex sicon text-success"></i>
                <!--</div>-->
            </div>
        </div>
    </div>

</div>

<div class="row g-3">
    <div class="col-xl-4">
        <div class="dashboard-card p-3 mt-3">
            <h5><i class="bi bi-file-earmark-text"></i> Gate Pass</h5>
            <hr class="mt-0">
            <div class="leave-widget">
                <div class="leave-item">
                    <div class="text-secondary">
                        <i class="bi bi-file-earmark-break-fill me-2"></i>
                        <span>Pending</span>
                    </div>
                    <span class="badge text-bg-secondary">12</span>
                </div>

                <div class="leave-item">
                    <div class="text-success">
                        <i class="bi bi-file-earmark-check-fill me-2"></i>
                        <span>Approved</span>
                    </div>
                    <span class="badge text-bg-success">48</span>
                </div>

                <div class="leave-item">
                    <div class="text-danger">
                        <i class="bi bi-file-earmark-excel-fill me-2"></i>
                        <span>Rejected</span>
                    </div>
                    <span class="badge text-bg-danger">4</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="dashboard-card p-3 mt-3">
            <h5><i class="bi bi-journal-check"></i> Quick Action</h5>
            <hr class="mt-0">
            <div class="card-body">
                <div class="row g-2">
                    <div class="col-4">
                        <button class="btn quick-btn w-100 lh-1" (click)="dataService.pgType='inq';">
                            <i class="bi bi-card-heading text-primary fs-1 d-block mb-1"></i>
                            <span class="small">Enquery Form</span>
                        </button>
                    </div>
                    <div class="col-4">
                        <button class="btn quick-btn w-100 lh-1" data-bs-toggle="modal" data-bs-target="#dataModal" (click)="frmEnquery('list')">
                            <i class="bi bi-file-earmark-spreadsheet text-primary fs-1 d-block mb-1"></i>
                            <span class="small">Enquery Data</span>
                        </button>
                    </div>
                    <div class="col-4">
                        <button class="btn quick-btn w-100 lh-1">
                            <i class="bi bi-folder-fill text-warning fs-1 d-block mb-1"></i>
                            <span class="small">Document</span>
                        </button>
                    </div>
                    <div class="col-4">
                        <button class="btn quick-btn w-100 lh-1">
                            <i class="bi bi-folder-fill text-warning fs-1 d-block mb-1"></i>
                            <span class="small">Document</span>
                        </button>
                    </div>
                    <div class="col-4">
                        <button class="btn quick-btn w-100 lh-1">
                            <i class="bi bi-folder-fill text-warning fs-1 d-block mb-1"></i>
                            <span class="small">Document</span>
                        </button>
                    </div>
                    <div class="col-4">
                        <button class="btn quick-btn w-100 lh-1">
                            <i class="bi bi-folder-fill text-warning fs-1 d-block mb-1"></i>
                            <span class="small">Document</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="dashboard-card p-3 mt-3">
            <h5><i class="bi bi-calendar3"></i> Daily Activity Log</h5>
            <hr class="mt-0">
            <div class="activity-item">
                <i class="bi bi-check2-square"></i>
                New Teacher Joined
            </div>

            <div class="activity-item">
                <i class="bi bi-check2-square"></i>
                Leave Approved
            </div>

            <div class="activity-item">
                <i class="bi bi-check2-square"></i>
                Fee Collection Updated
            </div>
        </div>
    </div>
</div>

<div class="row g-3">
    <div class="col-xl-4">
        <div class="dashboard-card p-3 mt-3" style="min-height: 250px;">
            <h5><i class="bi bi-check2-square"></i> Todo List</h5>
            <hr class="mt-0">
            <app-todo [stats]="false"  [title]="false"></app-todo>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="dashboard-card p-3 mt-3">
            <h5><i class="bi bi-card-checklist"></i> Complaints</h5>
            <hr class="mt-0">
            <ul class="mb-0">
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
                <li>Annual Evaluation - Next Week</li>
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
            </ul>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="dashboard-card p-3 mt-3">
            <h5><i class="bi bi-alarm"></i> Reminders</h5>
            <hr class="mt-0">
            <ul class="mb-0">
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
                <li>Annual Evaluation - Next Week</li>
                <li>Payroll Processing - Tomorrow</li>
                <li>Recruitment Drive - Friday</li>
            </ul>
        </div>
    </div>
</div>

<div class="dashboard-card p-3 mt-3">
    <app-event-calendar></app-event-calendar>
</div>
